class UserType {
  constructor() {}
  id = "";
  dob = "";
  phone = "";
  email = "";
  fullname = "";
  address = "";
  city = "";
  country = "";
  aboutme = "";
  roleid = 1;
  rolename = "";
  picture = "";
  company = "";
  position = "";
  pwd = "";
  pwdtoken = "";
}

class CourseType {
  constructor() {}
  id = "";
  title = "";
  description = "";
  code = "";
  groupcode = "";
  status = true;
  statusname = "";
}

class StageType {
  id = "";
  courseId = "";
  title = "";
  description = "";
  duration = 1;
  orderindex = 0;
  level = 1;
  levelname = "Easy";
}

class LessonType {
  id = "";
  stageId = "";
  title = "";
  description = "";
  notes = "";
  orderindex = 0;
  stagename = "";
  duration = 0;
}

class LessonTaskType {
  id = "";
  lessonId = "";
  title = "";
  description = "";
  tasktype = 1;
  tasktypename = "in class";
  orderindex = 0;
  level = 1;
  levelname = "Easy";
}

class FileType {
  id = "";
  filename = "";
  sourcetype = 0;
  sourceId = "";
  sourcedetId = "";
}

class ClassType {
  id = "";
  code = "";
  courseId = "";
  startdate = "";
  enddate = "";
  resperson = "";
}

class StudentType {
  id = "";
  studentId = "";
  classId = "";
  startdate = "";
  enddate = "";
  notes = "";
}

class PaymentType {
  id = "";
  payertype = 1;
  payertypename = "";
  classtitle = "";
  classId = "";
  amount = 0;
  payername = "";
  payerphone = "";
  payeremail = "";
  contactperson = "";
}

class InstallmentType {
  id= "";
  paymentId = "";
  paydate = new Date();
  amount = 0;
}

class PaymentTranType {
  id= "";
  paymentId = "";
  paydate = new Date();
  amount = 0;
  paytype = 1;
  rate = 1;
  info = "";
  currency = "AZN";
  studentid = "";
}

export {
  UserType,
  CourseType,
  StageType,
  LessonType,
  LessonTaskType,
  FileType,
  ClassType,
  StudentType,
  PaymentType,
  InstallmentType,
  PaymentTranType
};
